
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-writing/[id]",
      function () {
        return require("private-next-pages/my-writing/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-writing/[id]"])
      });
    }
  